<div class="card elevation-2" (mouseleave)="onMouseLeave()">
  <div class="card-header d-flex align-items-center justify-content-between gap-5">
    <span class="si-title-2">{{ 'BROUTER_MAP.ELEVATION.TITLE' | translate }}</span>
    <button
      type="button"
      class="btn btn-circle btn-ghost element-cancel"
      [attr.aria-label]="'SHARED.CLOSE' | translate"
      (click)="closed.emit()"
    ></button>
  </div>

  @if (chartOptions(); as options) {
    <si-chart
      echarts
      class="elevation-chart__chart d-block w-100"
      renderer="svg"
      [options]="options"
      (pointer)="onChartHover($event)"
    />
  } @else {
    <si-empty-state icon="element-trend" [heading]="'BROUTER_MAP.ELEVATION.NO_DATA' | translate" />
  }
</div>
